/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponseItemsInnerPeriod } from './ListOperations200ResponseItemsInnerPeriod';
import {
    ListOperations200ResponseItemsInnerPeriodFromJSON,
    ListOperations200ResponseItemsInnerPeriodFromJSONTyped,
    ListOperations200ResponseItemsInnerPeriodToJSON,
    ListOperations200ResponseItemsInnerPeriodToJSONTyped,
} from './ListOperations200ResponseItemsInnerPeriod';

/**
 * 支払通知書一覧のアイテム
 * @export
 * @interface ListNotices200ResponseItemsInner
 */
export interface ListNotices200ResponseItemsInner {
    /**
     * ID
     * @type {string}
     * @memberof ListNotices200ResponseItemsInner
     */
    id: string;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof ListNotices200ResponseItemsInner
     */
    serviceCategory: ListNotices200ResponseItemsInnerServiceCategoryEnum | null;
    /**
     * 支払日
     * @type {Date}
     * @memberof ListNotices200ResponseItemsInner
     */
    paymentDate: Date;
    /**
     * 
     * @type {ListOperations200ResponseItemsInnerPeriod}
     * @memberof ListNotices200ResponseItemsInner
     */
    paymentPeriod: ListOperations200ResponseItemsInnerPeriod;
    /**
     * 合計金額
     * @type {number}
     * @memberof ListNotices200ResponseItemsInner
     */
    totalAmount: number;
}


/**
 * @export
 */
export const ListNotices200ResponseItemsInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ListNotices200ResponseItemsInnerServiceCategoryEnum = typeof ListNotices200ResponseItemsInnerServiceCategoryEnum[keyof typeof ListNotices200ResponseItemsInnerServiceCategoryEnum];


/**
 * Check if a given object implements the ListNotices200ResponseItemsInner interface.
 */
export function instanceOfListNotices200ResponseItemsInner(value: object): value is ListNotices200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('paymentDate' in value) || value['paymentDate'] === undefined) return false;
    if (!('paymentPeriod' in value) || value['paymentPeriod'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function ListNotices200ResponseItemsInnerFromJSON(json: any): ListNotices200ResponseItemsInner {
    return ListNotices200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListNotices200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListNotices200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'serviceCategory': json['service_category'],
        'paymentDate': (new Date(json['payment_date'])),
        'paymentPeriod': ListOperations200ResponseItemsInnerPeriodFromJSON(json['payment_period']),
        'totalAmount': json['total_amount'],
    };
}

export function ListNotices200ResponseItemsInnerToJSON(json: any): ListNotices200ResponseItemsInner {
    return ListNotices200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListNotices200ResponseItemsInnerToJSONTyped(value?: ListNotices200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'service_category': value['serviceCategory'],
        'payment_date': ((value['paymentDate']).toISOString().substring(0,10)),
        'payment_period': ListOperations200ResponseItemsInnerPeriodToJSON(value['paymentPeriod']),
        'total_amount': value['totalAmount'],
    };
}

